<template>
    <!-- 覆盖区域 -->
    <div class="fugaiswipermain">
        <!-- tab切换 -->
        <!-- <div class="tab_check containers">
            <div @click="coveraged" :class="tabCheck=='已覆盖'?'ons':''">已覆盖</div>
            <div @click="beforeCoverage" :class="tabCheck=='拟覆盖'?'ons':''">拟覆盖</div>
        </div> -->
        <!-- <div v-if="tabCheck==='已覆盖'"> -->
        <swiper ref="mySwiper" :options="swiperOption">
            <!-- slides -->
            <swiper-slide class="swiper-slide" v-for="(item,index) in fugaiswiper" :key="index">
                <div class="bg_main" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave" :style="{background:'url('+item.pic+') no-repeat'}">
                    <div class="swiper-address">
                        <span class="swiper-province">{{item.province}}</span>
                        <p class="swiper-city">{{item.city}}</p>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <!-- </div> -->

        <!-- <div v-else>
            <swiper ref="beforemySwiper" :options="beforeswiperOption"> -->
        <!-- slides -->
        <!-- <swiper-slide class="swiper-slide" v-for="(item,index) in fugaiswiper[1].mian" :key="index">
                    <div class="bg_main" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave" :style="{background:'url('+item.pic+') no-repeat'}">
                        <div class="swiper-address">
                            <span class="swiper-province">{{item.province}}</span>
                            <p class="swiper-city">{{item.city}}</p>
                        </div>
                    </div>
                </swiper-slide> -->
        <!-- </swiper> -->
        <!-- </div> -->


        <div class="playbtn">
            <div class="swiper-button-prev" slot="button-prev">
                <img src="../../assets/imgs/dedeauto/icon_left.png">
            </div>
            <div class="swiper_play" ref="playorstop" @click="stop">
                <img src="../../assets/imgs/dedeauto/icon_stop.png" v-show="btnplay===true">
                <img src="../../assets/imgs/dedeauto/icon_play.png" v-show="btnplay===false">
            </div>
            <div class="swiper-button-next" slot="button-next">
                <img src="../../assets/imgs/dedeauto/icon_right.png">
            </div>
        </div>
    </div>
</template>

<script>
    import {
        swiper,
        swiperSlide
    } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        props: {
            fugaiswiper: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                // tab切换
                // tabCheck: '已覆盖',
                //点击播放暂停按钮
                btnplay: true, //默认播放

                //swiper轮播
                swiperOption: {
                    loop: true, //开启循环模式
                    // speed: 2000,
                    slidesPerView: 7,
                    spaceBetween: 40,
                    //设置点击箭头
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    //自动轮播
                    autoplay: {
                        delay: 2000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true //允许分页点击跳转
                    },
                },
            }
        },
        components: {
            swiper,
            swiperSlide
        },

        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper;
            }
        },
        mounted() {
            this.swiper.slideTo(3, 1000, false);
        },
        methods: {
            // coveraged() {
            //     this.tabCheck = '已覆盖';
            //     this.swiperData = this.fugaiswiper[0].mian;
            // },
            // beforeCoverage() {
            //     this.tabCheck = '拟覆盖';
            //     this.swiperData = this.fugaiswiper[1].mian;
            // },
            stop() { //通过调用鼠标移入移除间接实现暂停播放
                this.btnplay = !this.btnplay;
                this.btnplay?this.on_bot_leave(): this.on_bot_enter();
            },

            on_bot_enter() {
                this.swiper.autoplay.stop();
            },
            on_bot_leave() {
                this.swiper.autoplay.start();
            },

        }
    }
</script>

<style scoped>
    .swiper-button-next,
    .swiper-button-prev {
        position: static;
        margin: 0 10px;
        top: auto;
    }
</style>